import * as urlLocales from '@blueberry/constants/urlLocale';
import { languages } from '@blueberry/constants/languages';

/**
 * client selectable languages.
 */
export const SELECTABLE_LANGUAGES = {
  [urlLocales.ZH_TW]: languages[urlLocales.ZH_TW],
  [urlLocales.ZH_HK]: languages[urlLocales.ZH_HK],
  [urlLocales.EN_MY]: languages[urlLocales.EN_MY],
  [urlLocales.EN_SG]: languages[urlLocales.EN_SG],
  [urlLocales.ID_ID]: languages[urlLocales.ID_ID],
  [urlLocales.KO_KR]: languages[urlLocales.KO_KR],
  [urlLocales.JA_JP]: languages[urlLocales.JA_JP],
  [urlLocales.TH_TH]: languages[urlLocales.TH_TH],
  [urlLocales.VI_VN]: languages[urlLocales.VI_VN],
};
/**
 *  language mapping by the region code.
 */
export const DEFAULT_REGION_LANGUAGE = {
  [urlLocales.TW]: languages[urlLocales.ZH_TW],
  [urlLocales.HK]: languages[urlLocales.ZH_HK],
  [urlLocales.MY]: languages[urlLocales.EN_MY],
  [urlLocales.ID]: languages[urlLocales.ID_ID],
  [urlLocales.SG]: languages[urlLocales.EN_SG],
  [urlLocales.KR]: languages[urlLocales.KO_KR],
  [urlLocales.TH]: languages[urlLocales.TH_TH],
  [urlLocales.JP]: languages[urlLocales.JA_JP],
  [urlLocales.VN]: languages[urlLocales.VI_VN],
};

/**
 * language map that can not be selected by client, but is supported application wise!
 */
export const APP_LANGUAGES = {
  ...SELECTABLE_LANGUAGES,
  ...DEFAULT_REGION_LANGUAGE,
};

/* ********** Share Media ************* */

const FACKEBOOK = 'Facebook';
const TWITTER = 'Twitter';
const EMAIL = 'Email';
const LINE = 'Line';

const SHARE_MEDIA = {
  [urlLocales.TW]: [FACKEBOOK, LINE],
  [urlLocales.HK]: [FACKEBOOK, EMAIL],
  [urlLocales.MY]: [FACKEBOOK, TWITTER, EMAIL],
  [urlLocales.ID]: [FACKEBOOK, EMAIL, LINE],
  [urlLocales.SG]: [FACKEBOOK, TWITTER, EMAIL],
  [urlLocales.KR]: [FACKEBOOK, EMAIL],
  [urlLocales.TH]: [FACKEBOOK, TWITTER, EMAIL, LINE],
  [urlLocales.JP]: [FACKEBOOK, TWITTER, EMAIL, LINE],
};

export const getShareMedia = region => {
  const socials = SHARE_MEDIA[region] || SHARE_MEDIA[urlLocales.HK];

  return {
    socials,
  };
};



// WEBPACK FOOTER //
// ./app/config/site.js